import React from 'react';
import LoaderIcon from 'react-icons/lib/fa/spinner'

import './loader.styl';

const Loader = props => {
  return (
    <div className="ifdw-loader">
      <LoaderIcon/>
    </div>
  )
};

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/Loader/index.js
 **/